function posixSplitPath(filename: string) {
  // eslint-disable-next-line no-useless-escape
  const splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
  return splitPathRe.exec(filename)!.slice(1);
}

export function extname(path: string) {
  return posixSplitPath(path)[3];
}
